import { reducerWithInitialState } from "typescript-fsa-reducers";

import {
  selectedFeaturesChanged,
  occupationTypeChanged,
  loadCompaniesByCompanyValues,
  bootstrapValuesIndex,
} from "../actions";
import { bootstrapped } from "../../common/actions/Auth";

export interface CompanyValueSearchState {
  companyId?: EntityId;
  selectedFeatures: number[];
  occupationType: string | null;
  page: number;
  companies: EntityId[];
  projects: EntityId[];
  isLoadingCompanies: boolean;
  isLoadedCompanies: boolean;
  errorMessage?: string;
  totalCompaniesCount: number;
}

const InitialState: CompanyValueSearchState = {
  selectedFeatures: [],
  occupationType: null,
  page: 1,
  companies: [],
  projects: [],
  isLoadingCompanies: false,
  isLoadedCompanies: false,
  totalCompaniesCount: 0,
};

const searchReducer = reducerWithInitialState<CompanyValueSearchState>(InitialState)
  .case(bootstrapValuesIndex, (state, { result }) => {
    const { selected_features, total_companies_count, ...rest } = result;
    return {
      ...state,
      ...rest,
      selectedFeatures: selected_features,
      totalCompaniesCount: total_companies_count,
    };
  })
  .case(bootstrapped, (state, data) => {
    return {
      ...state,
      occupationType: data.current_user && data.current_user.occupation_type,
    };
  })
  .case(selectedFeaturesChanged, (state, result) => {
    return {
      ...state,
      selectedFeatures: result.selectedFeatures,
    };
  })
  .case(occupationTypeChanged, (state, result) => {
    return {
      ...state,
      occupationType: result.occupationType,
    };
  })
  .case(loadCompaniesByCompanyValues.started, state => {
    return { ...state, isLoadingCompanies: true };
  })
  .case(loadCompaniesByCompanyValues.done, (state, { result: actionRes }) => {
    const { result } = actionRes;
    return {
      ...state,
      companies: actionRes.page > 1 ? state.companies.concat(result.companies) : result.companies,
      projects: actionRes.page > 1 ? state.projects.concat(result.projects) : result.projects,
      isLoadingCompanies: false,
      isLoadedCompanies: true,
      page: actionRes.page,
      totalCompaniesCount: result.total_companies_count,
    };
  })
  .case(loadCompaniesByCompanyValues.failed, (state, err) => {
    return { ...state, isLoadingCompanies: false, isLoadedCompanies: false, errorMessage: err.error.message };
  });

export default searchReducer;



// WEBPACK FOOTER //
// ./frontend/src/company_values/reducers/search.ts